import PageHeader from "../Page/page_header";
import PageContextProvider from "../Page/page_context";
import PageStatisticsHeader from "../Page/page_statistics_header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { Card, CardContent } from "../ui/card";
import { UserIcon, Settings2Icon, Gamepad2Icon, MessageCircleIcon } from "lucide-react";
import PageContainer from "../Page/page_container";
import FeedbackManager from "./feedback_manager"

const AdministrationRendering = ({ title, header, type, game_id }) => {
  return (
    <PageContextProvider>
      <div className="min-h-screen default_page_style ">
        <div className="max-w-7xl mx-auto">
          <PageHeader title={header} />
          {type === "Statistics" && <PageStatisticsHeader game_id={game_id} />}
          <div className="mt-4">
            <Card className="border shadow-md overflow-hidden space-y-4">
              <Tabs defaultValue="user-management" className="w-full dark:bg-[var(--background-dark)]">
                <TabsList className="grid w-full grid-cols-4 dark:bg-[var(--header-color-dark)]">
                  <TabsTrigger
                    value="user-management"
                    className="flex items-center gap-2 data-[state=active]:bg-purple-700  dark:data-[state=active]:bg-purple-700  data-[state=active]:text-white  dark:text-white"
                  >
                    <UserIcon className="h-4 w-4" />
                    User Management
                  </TabsTrigger>
                  <TabsTrigger
                    value="component-management"
                    className="flex items-center gap-2 data-[state=active]:bg-purple-700  dark:data-[state=active]:bg-purple-700  data-[state=active]:text-white dark:text-white"
                  >
                    <Settings2Icon className="h-4 w-4" />
                    Component Management
                  </TabsTrigger>
                  <TabsTrigger
                    value="game-management"
                    className="flex items-center gap-2  data-[state=active]:bg-purple-700  dark:data-[state=active]:bg-purple-700 data-[state=active]:text-white  dark:text-white"
                  >
                    <Gamepad2Icon className="h-4 w-4" />
                    Game Management
                  </TabsTrigger>
                  <TabsTrigger
                    value="feedback-management"
                    className="flex items-center gap-2  data-[state=active]:bg-purple-700  dark:data-[state=active]:bg-purple-700 data-[state=active]:text-white  dark:text-white"
                  >
                    <MessageCircleIcon className="h-4 w-4" />
                    Feedback Management
                  </TabsTrigger>
                </TabsList>
                <CardContent>
                  <TabsContent value="user-management" className="mt-0">
                    <div className="col_full">
                      <PageContainer title="User Manager" game_id={game_id} />
                    </div>
                    <div className="col_full">
                      <PageContainer title="Page Manager" game_id={game_id} />
                    </div>
                  </TabsContent>
                  <TabsContent value="component-management" className="mt-0">
                    <div className="grid grid-cols-1 gap-4">
                      <div className="col_full">
                        <PageContainer title="Component Manager" game_id={game_id} />
                      </div>
                    </div>
                  </TabsContent>
                  <TabsContent value="game-management" className="mt-0">
                    <div className="grid grid-cols-1 gap-4">
                      <div className="col_full">
                        <PageContainer title="Game Manager" game_id={game_id} />
                      </div>
                    </div>
                  </TabsContent>
                  <TabsContent value="feedback-management" className="mt-0">
                    <div className="grid grid-cols-1 gap-4">
                      <div className="col_full">
                        <FeedbackManager />
                      </div>
                    </div>
                  </TabsContent>
                </CardContent>
              </Tabs>
            </Card>
          </div>
        </div>
      </div>
    </PageContextProvider>
  );
};

export default AdministrationRendering; 